import { Circle } from '../../CanvasGui/Circle';
import { Colour } from '../../Colour/Colour';
import { ColourIndex, ColouringMode } from '../../Colour/Colourable';
import { InputHandler, InputListener, KeyInputListener } from '../../Input/InputHandler';
import { NumPair, Point } from '../../Misc/Utils';
import { Scene } from '../../Scene';
import { AssistiveObject } from '../AssistiveObjects/AssistiveObjectsHandler';
import { BVector, BVectorMode } from '../Shapes/BVector';

export class BVectorBuilder implements InputListener, KeyInputListener, AssistiveObject{
    private shape: BVector | null = null;
    private curScene: Scene;
    private inputHandler: InputHandler;

    private isClicking: boolean = false;
    
    private cursorTrackingCircle: Circle = new Circle();
    private cursorPos: Point = [0,0];

    constructor(dimens: NumPair, curScene: Scene, inputHandler: InputHandler){
        this.curScene = curScene
        this.inputHandler = inputHandler;
        this.setupCursorTrackingCircle();
        this.curScene.getAssistiveObjectsHolder().addAssistiveObject(this);
    }
    
    onKeyDown(key: string): void {
        if(key == 'Escape'){
            this.stopConstruction();
        }
    }

    onKeyUp(key: string): void {
        //none
    }
    
    public startConstruction(){
        this.curScene.onObjectCreationStart();
        this.inputHandler.addListener(this);
        this.inputHandler.addKeyListener(this);
    }

    public stopConstruction(){
        if(this.shape){
            this.shape.setBVectorMode(BVectorMode.None);
            this.shape.removeLastVertex(); //this was tracking vertex, and so removing
            this.shape.evaluateShouldCloseVectorPath(); 
        }
        this.inputHandler.removeListener(this);
        this.inputHandler.removeKeyListener(this);
        this.curScene.onObjectCreationFinish();
    }

    onMouseDown(point: Point): void {
        this.isClicking = true;
        if(this.shape){
            console.log("on mouse down:"+point);
            this.shape.addAsRelativePoint(point);
        }else{
            this.shape = new BVector(point, this.curScene.getFrameRange())
            this.shape.addAsRelativePoint(point); //Added so that when mouse moves, last vertex tracks the mouse pointer
            this.curScene.addBObject(this.shape);
            this.shape.setBVectorMode(BVectorMode.Build);
            this.curScene.getAssistiveObjectsHolder().removeAssistiveObject(this); //Once user starts drawing, do not show a circle at the cursor position.
            
        }
    }

    onMouseUp(point: Point): void {
        this.isClicking = false;
        if(this.shape){
            this.shape.setBVectorMode(BVectorMode.Build);
            if(this.shape.isClosedLoop()){ //User has closed the vector by clicking onthe first vertex
                console.log("is closed loop");
                this.stopConstruction();
            }
        }
    }

    onDoubleClick(point: Point): void {
        //do nothing
    }

    onMouseMove(from: Point, to: Point): void {
        if(this.shape){
            if(this.isClicking){ //User is dragging mouse while clicking to add a vertex, so modify control point
                //console.log("isClicking on mouse move to:"+to)
                this.shape.setBVectorMode(BVectorMode.ControlPointDragging);
                this.shape.setControlPointOfLastButOneVertexAsRelative(to);
            }else{ //User is just moving mouse, just track the mouse
                this.shape.setLastVertexAsRelative(to);
            }
        }else{
            //User is yet to start creating the shape
            this.cursorPos = [to[0], to[1]];
        }
    }

    draw(canvasCtx: CanvasRenderingContext2D, playStatus: number): void {
        if(!this.shape){ //if the shape hasnt been started by the user
            //console.log("drawing circle at "+this.cursorPos);
            this.cursorTrackingCircle.drawCircle(canvasCtx, this.cursorPos);
        }
    }

    private setupCursorTrackingCircle(){
        this.cursorTrackingCircle.setRadius(3);
        this.cursorTrackingCircle.setColour(ColourIndex.Stroke, new Colour({h:199, s:0.3, v:0.5})); //grey
        this.cursorTrackingCircle.setColouringMode(ColouringMode.Stroke);
    }
}